<template>
    <div class="card">
        <form method="post" :action="status_change_submit_url" class="card-body">
            <input type="hidden" :value="csrf_token" name="_token" />
            <div class="flex">
                <div class="w-1/6">
                    <h4 class="card-title" style="padding-left: 4px;">Status</h4>
                </div>
                <div class="w-5/12"></div>
                <div class="w-1/3">
                    <select v-model="status" class="form-control" name="status" :disabled="employer == 'false'">
                        <option :value="0">Ingediend</option>
                        <option :value="1">Goedgekeurd</option>
                        <option :value="2">Afgekeurd</option>
                    </select>
                </div>
            </div>
            <br>
            <div class="form-group" v-if="status === 1 || status === 2">
                <label for="reason" v-if="status === 2"><b>Reden van afkeuring</b></label>
                <label for="reason" v-if="status === 1"><b>Reden van goedkeuring</b></label>
                <small class="text-danger" v-if="reason_error != ''">* {{ reason_error }}</small>
                <textarea class="form-control" id="reason" name="reason" rows="4" v-model="reason_data" :disabled="employer == 'false'"></textarea>
            </div>

            <button class="btn btn-secondary float-right" v-if="employer == 'true'">Versturen</button>
        </form>
    </div>
</template>

<script>
    export default {
        props: {
            current_status: {
                Default: 0,
                Type: Number
            },
            reason: {
                Type: String,
                Default: "",
            },
            status_change_submit_url: {
                Required: true,
                Type: String,
            },
            reason_error: "",
            employer: {
                Default: false,
                Type: Boolean,
            },
        },
        data: function () {
            return {
                status: 0,
                csrf_token: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
                reason_data: "",
            }
        },
        mounted() {
            this.status = parseInt(this.current_status);
            this.reason_data = this.reason;
        }
    }
</script>

<style scoped>

</style>
